export const ldTheme = {
  fonts: {
    tiny: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    xSmall: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    small: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    smallPlus: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    medium: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    mediumPlus: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    large: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 400,
    },
    xLarge: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
    xLargePlus: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
    xxLarge: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
    xxLargePlus: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
    superLarge: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
    mega: {
      fontFamily: "neueCond",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      fontSize: "1rem",
      fontWeight: 600,
    },
  },
  borderRadiusNone: "0",
  borderRadiusSmall: "2px",
  borderRadiusMedium: "4px",
  borderRadiusLarge: "6px",
  borderRadiusXLarge: "8px",
  borderRadiusCircular: "10000px",
  fontSizeBase100: "10px",
  fontSizeBase200: "12px",
  fontSizeBase300: "16px",
  fontSizeBase400: "16px",
  fontSizeBase500: "20px",
  fontSizeBase600: "24px",
  fontSizeHero700: "28px",
  fontSizeHero800: "32px",
  fontSizeHero900: "40px",
  fontSizeHero1000: "68px",
  lineHeightBase100: "14px",
  lineHeightBase200: "16px",
  lineHeightBase300: "20px",
  lineHeightBase400: "22px",
  lineHeightBase500: "28px",
  lineHeightBase600: "32px",
  lineHeightHero700: "36px",
  lineHeightHero800: "40px",
  lineHeightHero900: "52px",
  lineHeightHero1000: "92px",
  fontFamilyBase: "neueCond",
  /*   fontFamilyBase:
      "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif", */
  fontFamilyMonospace: "Consolas, 'Courier New', Courier, monospace",
  fontFamilyNumeric:
    "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  strokeWidthThin: "1px",
  strokeWidthThick: "2px",
  strokeWidthThicker: "3px",
  strokeWidthThickest: "4px",
  spacingHorizontalNone: "0",
  spacingHorizontalXXS: "2px",
  spacingHorizontalXS: "4px",
  spacingHorizontalSNudge: "6px",
  spacingHorizontalS: "8px",
  spacingHorizontalMNudge: "10px",
  spacingHorizontalM: "12px",
  spacingHorizontalL: "16px",
  spacingHorizontalXL: "20px",
  spacingHorizontalXXL: "24px",
  spacingHorizontalXXXL: "32px",
  spacingVerticalNone: "0",
  spacingVerticalXXS: "2px",
  spacingVerticalXS: "4px",
  spacingVerticalSNudge: "6px",
  spacingVerticalS: "8px",
  spacingVerticalMNudge: "10px",
  spacingVerticalM: "12px",
  spacingVerticalL: "16px",
  spacingVerticalXL: "20px",
  spacingVerticalXXL: "24px",
  spacingVerticalXXXL: "32px",
  durationUltraFast: "50ms",
  durationFaster: "100ms",
  durationFast: "150ms",
  durationNormal: "200ms",
  durationGentle: "250ms",
  durationSlow: "300ms",
  durationSlower: "400ms",
  durationUltraSlow: "500ms",
  curveAccelerateMax: "cubic-bezier(1,0,1,1)",
  curveAccelerateMid: "cubic-bezier(0.7,0,1,0.5)",
  curveAccelerateMin: "cubic-bezier(0.8,0,1,1)",
  curveDecelerateMax: "cubic-bezier(0,0,0,1)",
  curveDecelerateMid: "cubic-bezier(0.1,0.9,0.2,1)",
  curveDecelerateMin: "cubic-bezier(0.33,0,0.1,1)",
  curveEasyEaseMax: "cubic-bezier(0.8,0,0.1,1)",
  curveEasyEase: "cubic-bezier(0.33,0,0.67,1)",
  curveLinear: "cubic-bezier(0,0,1,1)",
  colorNeutralForeground1: "#323130",
  colorNeutralForeground1Hover: "#323130",
  colorNeutralForeground1Pressed: "#323130",
  colorNeutralForeground1Selected: "#323130",
  colorNeutralForeground2: "#605e5c",
  colorNeutralForeground2Hover: "#323130",
  colorNeutralForeground2Pressed: "#323130",
  colorNeutralForeground2Selected: "#323130",
  colorNeutralForeground2BrandHover: "#ff6600",
  colorNeutralForeground2BrandPressed: "#e65c00",
  colorNeutralForeground2BrandSelected: "#ff6600",
  colorNeutralForeground3: "#a19f9d",
  colorNeutralForeground3Hover: "#605e5c",
  colorNeutralForeground3Pressed: "#605e5c",
  colorNeutralForeground3Selected: "#605e5c",
  colorNeutralForeground3BrandHover: "#ff6600",
  colorNeutralForeground3BrandPressed: "#e65c00",
  colorNeutralForeground3BrandSelected: "#ff6600",
  colorNeutralForeground4: "#d0d0d0",
  colorNeutralForegroundDisabled: "#c8c6c4",
  colorNeutralForegroundInvertedDisabled: "rgba(255, 255, 255, 0.4)",
  colorBrandForegroundLink: "#e65c00",
  colorBrandForegroundLinkHover: "#c24e00",
  colorBrandForegroundLinkPressed: "#8f3900",
  colorBrandForegroundLinkSelected: "#e65c00",
  colorNeutralForeground2Link: "#605e5c",
  colorNeutralForeground2LinkHover: "#323130",
  colorNeutralForeground2LinkPressed: "#323130",
  colorNeutralForeground2LinkSelected: "#323130",
  colorCompoundBrandForeground1: "#ff6600",
  colorCompoundBrandForeground1Hover: "#e65c00",
  colorCompoundBrandForeground1Pressed: "#c24e00",
  colorBrandForeground1: "#ff6600",
  colorBrandForeground2: "#e65c00",
  colorBrandForeground2Hover: "#323130",
  colorBrandForeground2Pressed: "#323130",
  colorNeutralForeground1Static: "#323130",
  colorNeutralForegroundStaticInverted: "#ffffff",
  colorNeutralForegroundInverted: "#ffffff",
  colorNeutralForegroundInvertedHover: "#ffffff",
  colorNeutralForegroundInvertedPressed: "#ffffff",
  colorNeutralForegroundInvertedSelected: "#ffffff",
  colorNeutralForegroundInverted2: "#ffffff",
  colorNeutralForegroundOnBrand: "#ffffff",
  colorNeutralForegroundInvertedLink: "#ffffff",
  colorNeutralForegroundInvertedLinkHover: "#ffffff",
  colorNeutralForegroundInvertedLinkPressed: "#ffffff",
  colorNeutralForegroundInvertedLinkSelected: "#ffffff",
  colorBrandForegroundInverted: "#ff781f",
  colorBrandForegroundInvertedHover: "#ffa366",
  colorBrandForegroundInvertedPressed: "#ff781f",
  colorBrandForegroundOnLight: "#ff6600",
  colorBrandForegroundOnLightHover: "#e65c00",
  colorBrandForegroundOnLightPressed: "#c24e00",
  colorBrandForegroundOnLightSelected: "#c24e00",
  colorNeutralBackground1: "#ffffff",
  colorNeutralBackground1Hover: "#f3f2f1",
  colorNeutralBackground1Pressed: "#e1dfdd",
  colorNeutralBackground1Selected: "#edebe9",
  colorNeutralBackground2: "#faf9f8",
  colorNeutralBackground2Hover: "#f3f2f1",
  colorNeutralBackground2Pressed: "#e1dfdd",
  colorNeutralBackground2Selected: "#edebe9",
  colorNeutralBackground3: "#f3f2f1",
  colorNeutralBackground3Hover: "#edebe9",
  colorNeutralBackground3Pressed: "#d0d0d0",
  colorNeutralBackground3Selected: "#e1dfdd",
  colorNeutralBackground4: "#f3f2f1",
  colorNeutralBackground4Hover: "#faf9f8",
  colorNeutralBackground4Pressed: "#f3f2f1",
  colorNeutralBackground4Selected: "#ffffff",
  colorNeutralBackground5: "#edebe9",
  colorNeutralBackground5Hover: "#f3f2f1",
  colorNeutralBackground5Pressed: "#f3f2f1",
  colorNeutralBackground5Selected: "#faf9f8",
  colorNeutralBackground6: "#edebe9",
  colorNeutralBackgroundInverted: "#605e5c",
  colorNeutralBackgroundStatic: "#333333",
  colorNeutralBackgroundAlpha: "transparent",
  colorNeutralBackgroundAlpha2: "transparent",
  colorSubtleBackground: "transparent",
  colorSubtleBackgroundHover: "#f3f2f1",
  colorSubtleBackgroundPressed: "#e1dfdd",
  colorSubtleBackgroundSelected: "#edebe9",
  colorSubtleBackgroundLightAlphaHover: "rgba(255, 255, 255, 0.8)",
  colorSubtleBackgroundLightAlphaPressed: "rgba(255, 255, 255, 0.5)",
  colorSubtleBackgroundLightAlphaSelected: "transparent",
  colorSubtleBackgroundInverted: "transparent",
  colorSubtleBackgroundInvertedHover: "rgba(0, 0, 0, 0.1)",
  colorSubtleBackgroundInvertedPressed: "rgba(0, 0, 0, 0.3)",
  colorSubtleBackgroundInvertedSelected: "rgba(0, 0, 0, 0.2)",
  colorTransparentBackground: "transparent",
  colorTransparentBackgroundHover: "transparent",
  colorTransparentBackgroundPressed: "transparent",
  colorTransparentBackgroundSelected: "transparent",
  colorNeutralBackgroundDisabled: "#f3f2f1",
  colorNeutralBackgroundInvertedDisabled: "rgba(255, 255, 255, 0.1)",
  colorNeutralStencil1: "#edebe9",
  colorNeutralStencil2: "#faf9f8",
  colorNeutralStencil1Alpha: "rgba(0, 0, 0, 0.1)",
  colorNeutralStencil2Alpha: "rgba(0, 0, 0, 0.05)",
  colorBackgroundOverlay: "rgba(0, 0, 0, 0.4)",
  colorScrollbarOverlay: "rgba(0, 0, 0, 0.5)",
  colorBrandBackground: "#ff6600",
  colorBrandBackgroundHover: "#e65c00",
  colorBrandBackgroundPressed: "#8f3900",
  colorBrandBackgroundSelected: "#c24e00",
  colorCompoundBrandBackground: "#ff6600",
  colorCompoundBrandBackgroundHover: "#e65c00",
  colorCompoundBrandBackgroundPressed: "#c24e00",
  colorBrandBackgroundStatic: "#ff6600",
  colorBrandBackground2: "#fff9f5",
  colorBrandBackground2Hover: "#f3f2f1",
  colorBrandBackground2Pressed: "#e1dfdd",
  colorBrandBackgroundInverted: "#ffffff",
  colorBrandBackgroundInvertedHover: "#fff9f5",
  colorBrandBackgroundInvertedPressed: "#ffd1b3",
  colorBrandBackgroundInvertedSelected: "#ffe7d6",
  colorNeutralStrokeAccessible: "#605e5c",
  colorNeutralStrokeAccessibleHover: "#605e5c",
  colorNeutralStrokeAccessiblePressed: "#605e5c",
  colorNeutralStrokeAccessibleSelected: "#ff6600",
  colorNeutralStroke1: "#d0d0d0",
  colorNeutralStroke1Hover: "#c8c6c4",
  colorNeutralStroke1Pressed: "#c8c6c4",
  colorNeutralStroke1Selected: "#c8c6c4",
  colorNeutralStroke2: "#e1dfdd",
  colorNeutralStroke3: "#f3f2f1",
  colorNeutralStrokeSubtle: "#ff6600",
  colorNeutralStrokeOnBrand: "#ffffff",
  colorNeutralStrokeOnBrand2: "#ffffff",
  colorNeutralStrokeOnBrand2Hover: "#ffffff",
  colorNeutralStrokeOnBrand2Pressed: "#ffffff",
  colorNeutralStrokeOnBrand2Selected: "#ffffff",
  colorBrandStroke1: "#ff6600",
  colorBrandStroke2: "#ffd1b3",
  colorBrandStroke2Hover: "#323130",
  colorBrandStroke2Pressed: "#323130",
  colorBrandStroke2Contrast: "#e1dfdd",
  colorCompoundBrandStroke: "#ff6600",
  colorCompoundBrandStrokeHover: "#e65c00",
  colorCompoundBrandStrokePressed: "#c24e00",
  colorNeutralStrokeDisabled: "#e1dfdd",
  colorNeutralStrokeInvertedDisabled: "rgba(255, 255, 255, 0.4)",
  colorTransparentStroke: "transparent",
  colorTransparentStrokeInteractive: "transparent",
  colorTransparentStrokeDisabled: "transparent",
  colorNeutralStrokeAlpha: "#605e5c",
  colorNeutralStrokeAlpha2: "transparent",
  colorStrokeFocus1: "#ffffff",
  colorStrokeFocus2: "#000000",
  colorNeutralShadowAmbient: "rgba(0,0,0,0.12)",
  colorNeutralShadowKey: "rgba(0,0,0,0.14)",
  colorNeutralShadowAmbientLighter: "rgba(0,0,0,0.06)",
  colorNeutralShadowKeyLighter: "rgba(0,0,0,0.07)",
  colorNeutralShadowAmbientDarker: "rgba(0,0,0,0.20)",
  colorNeutralShadowKeyDarker: "rgba(0,0,0,0.24)",
  colorBrandShadowAmbient: "rgba(0,0,0,0.30)",
  colorBrandShadowKey: "rgba(0,0,0,0.25)",
  colorPaletteRedBackground1: "#fdf6f6",
  colorPaletteRedBackground2: "#f1bbbc",
  colorPaletteRedBackground3: "#d13438",
  colorPaletteRedForeground1: "#bc2f32",
  colorPaletteRedForeground2: "#751d1f",
  colorPaletteRedForeground3: "#d13438",
  colorPaletteRedBorderActive: "#d13438",
  colorPaletteRedBorder1: "#f1bbbc",
  colorPaletteRedBorder2: "#d13438",
  colorPaletteGreenBackground1: "#f1faf1",
  colorPaletteGreenBackground2: "#9fd89f",
  colorPaletteGreenBackground3: "#107c10",
  colorPaletteGreenForeground1: "#0e700e",
  colorPaletteGreenForeground2: "#094509",
  colorPaletteGreenForeground3: "#107c10",
  colorPaletteGreenBorderActive: "#107c10",
  colorPaletteGreenBorder1: "#9fd89f",
  colorPaletteGreenBorder2: "#107c10",
  colorPaletteDarkOrangeBackground1: "#fdf6f3",
  colorPaletteDarkOrangeBackground2: "#f4bfab",
  colorPaletteDarkOrangeBackground3: "#da3b01",
  colorPaletteDarkOrangeForeground1: "#c43501",
  colorPaletteDarkOrangeForeground2: "#7a2101",
  colorPaletteDarkOrangeForeground3: "#da3b01",
  colorPaletteDarkOrangeBorderActive: "#da3b01",
  colorPaletteDarkOrangeBorder1: "#f4bfab",
  colorPaletteDarkOrangeBorder2: "#da3b01",
  colorPaletteYellowBackground1: "#fffef5",
  colorPaletteYellowBackground2: "#fef7b2",
  colorPaletteYellowBackground3: "#fde300",
  colorPaletteYellowForeground1: "#817400",
  colorPaletteYellowForeground2: "#817400",
  colorPaletteYellowForeground3: "#fde300",
  colorPaletteYellowBorderActive: "#fde300",
  colorPaletteYellowBorder1: "#fef7b2",
  colorPaletteYellowBorder2: "#fde300",
  colorPaletteBerryBackground1: "#fdf5fc",
  colorPaletteBerryBackground2: "#edbbe7",
  colorPaletteBerryBackground3: "#c239b3",
  colorPaletteBerryForeground1: "#af33a1",
  colorPaletteBerryForeground2: "#6d2064",
  colorPaletteBerryForeground3: "#c239b3",
  colorPaletteBerryBorderActive: "#c239b3",
  colorPaletteBerryBorder1: "#edbbe7",
  colorPaletteBerryBorder2: "#c239b3",
  colorPaletteLightGreenBackground1: "#f2fbf2",
  colorPaletteLightGreenBackground2: "#a7e3a5",
  colorPaletteLightGreenBackground3: "#13a10e",
  colorPaletteLightGreenForeground1: "#11910d",
  colorPaletteLightGreenForeground2: "#0b5a08",
  colorPaletteLightGreenForeground3: "#13a10e",
  colorPaletteLightGreenBorderActive: "#13a10e",
  colorPaletteLightGreenBorder1: "#a7e3a5",
  colorPaletteLightGreenBorder2: "#13a10e",
  colorPaletteMarigoldBackground1: "#fefbf4",
  colorPaletteMarigoldBackground2: "#f9e2ae",
  colorPaletteMarigoldBackground3: "#eaa300",
  colorPaletteMarigoldForeground1: "#d39300",
  colorPaletteMarigoldForeground2: "#835b00",
  colorPaletteMarigoldForeground3: "#eaa300",
  colorPaletteMarigoldBorderActive: "#eaa300",
  colorPaletteMarigoldBorder1: "#f9e2ae",
  colorPaletteMarigoldBorder2: "#eaa300",
  colorPaletteRedForegroundInverted: "#dc5e62",
  colorPaletteGreenForegroundInverted: "#359b35",
  colorPaletteYellowForegroundInverted: "#fef7b2",
  colorPaletteDarkRedBackground2: "#d69ca5",
  colorPaletteDarkRedForeground2: "#420610",
  colorPaletteDarkRedBorderActive: "#750b1c",
  colorPaletteCranberryBackground2: "#eeacb2",
  colorPaletteCranberryForeground2: "#6e0811",
  colorPaletteCranberryBorderActive: "#c50f1f",
  colorPalettePumpkinBackground2: "#efc4ad",
  colorPalettePumpkinForeground2: "#712d09",
  colorPalettePumpkinBorderActive: "#ca5010",
  colorPalettePeachBackground2: "#ffddb3",
  colorPalettePeachForeground2: "#8f4e00",
  colorPalettePeachBorderActive: "#ff8c00",
  colorPaletteGoldBackground2: "#ecdfa5",
  colorPaletteGoldForeground2: "#6c5700",
  colorPaletteGoldBorderActive: "#c19c00",
  colorPaletteBrassBackground2: "#e0cea2",
  colorPaletteBrassForeground2: "#553e06",
  colorPaletteBrassBorderActive: "#986f0b",
  colorPaletteBrownBackground2: "#ddc3b0",
  colorPaletteBrownForeground2: "#50301a",
  colorPaletteBrownBorderActive: "#8e562e",
  colorPaletteForestBackground2: "#bdd99b",
  colorPaletteForestForeground2: "#294903",
  colorPaletteForestBorderActive: "#498205",
  colorPaletteSeafoamBackground2: "#a8f0cd",
  colorPaletteSeafoamForeground2: "#00723b",
  colorPaletteSeafoamBorderActive: "#00cc6a",
  colorPaletteDarkGreenBackground2: "#9ad29a",
  colorPaletteDarkGreenForeground2: "#063b06",
  colorPaletteDarkGreenBorderActive: "#0b6a0b",
  colorPaletteLightTealBackground2: "#a6e9ed",
  colorPaletteLightTealForeground2: "#00666d",
  colorPaletteLightTealBorderActive: "#00b7c3",
  colorPaletteTealBackground2: "#9bd9db",
  colorPaletteTealForeground2: "#02494c",
  colorPaletteTealBorderActive: "#038387",
  colorPaletteSteelBackground2: "#94c8d4",
  colorPaletteSteelForeground2: "#00333f",
  colorPaletteSteelBorderActive: "#005b70",
  colorPaletteBlueBackground2: "#a9d3f2",
  colorPaletteBlueForeground2: "#004377",
  colorPaletteBlueBorderActive: "#0078d4",
  colorPaletteRoyalBlueBackground2: "#9abfdc",
  colorPaletteRoyalBlueForeground2: "#002c4e",
  colorPaletteRoyalBlueBorderActive: "#004e8c",
  colorPaletteCornflowerBackground2: "#c8d1fa",
  colorPaletteCornflowerForeground2: "#2c3c85",
  colorPaletteCornflowerBorderActive: "#4f6bed",
  colorPaletteNavyBackground2: "#a3b2e8",
  colorPaletteNavyForeground2: "#001665",
  colorPaletteNavyBorderActive: "#0027b4",
  colorPaletteLavenderBackground2: "#d2ccf8",
  colorPaletteLavenderForeground2: "#3f3682",
  colorPaletteLavenderBorderActive: "#7160e8",
  colorPalettePurpleBackground2: "#c6b1de",
  colorPalettePurpleForeground2: "#341a51",
  colorPalettePurpleBorderActive: "#5c2e91",
  colorPaletteGrapeBackground2: "#d9a7e0",
  colorPaletteGrapeForeground2: "#4c0d55",
  colorPaletteGrapeBorderActive: "#881798",
  colorPaletteLilacBackground2: "#e6bfed",
  colorPaletteLilacForeground2: "#63276d",
  colorPaletteLilacBorderActive: "#b146c2",
  colorPalettePinkBackground2: "#f7c0e3",
  colorPalettePinkForeground2: "#80215d",
  colorPalettePinkBorderActive: "#e43ba6",
  colorPaletteMagentaBackground2: "#eca5d1",
  colorPaletteMagentaForeground2: "#6b0043",
  colorPaletteMagentaBorderActive: "#bf0077",
  colorPalettePlumBackground2: "#d696c0",
  colorPalettePlumForeground2: "#43002b",
  colorPalettePlumBorderActive: "#77004d",
  colorPaletteBeigeBackground2: "#d7d4d4",
  colorPaletteBeigeForeground2: "#444241",
  colorPaletteBeigeBorderActive: "#7a7574",
  colorPaletteMinkBackground2: "#cecccb",
  colorPaletteMinkForeground2: "#343231",
  colorPaletteMinkBorderActive: "#5d5a58",
  colorPalettePlatinumBackground2: "#cdd6d8",
  colorPalettePlatinumForeground2: "#3b4447",
  colorPalettePlatinumBorderActive: "#69797e",
  colorPaletteAnchorBackground2: "#bcc3c7",
  colorPaletteAnchorForeground2: "#202427",
  colorPaletteAnchorBorderActive: "#394146",
  colorStatusSuccessBackground1: "#f1faf1",
  colorStatusSuccessBackground2: "#9fd89f",
  colorStatusSuccessBackground3: "#107c10",
  colorStatusSuccessForeground1: "#0e700e",
  colorStatusSuccessForeground2: "#094509",
  colorStatusSuccessForeground3: "#107c10",
  colorStatusSuccessForegroundInverted: "#54b054",
  colorStatusSuccessBorderActive: "#107c10",
  colorStatusSuccessBorder1: "#9fd89f",
  colorStatusSuccessBorder2: "#107c10",
  colorStatusWarningBackground1: "#fff9f5",
  colorStatusWarningBackground2: "#fdcfb4",
  colorStatusWarningBackground3: "#f7630c",
  colorStatusWarningForeground1: "#bc4b09",
  colorStatusWarningForeground2: "#8a3707",
  colorStatusWarningForeground3: "#bc4b09",
  colorStatusWarningForegroundInverted: "#faa06b",
  colorStatusWarningBorderActive: "#f7630c",
  colorStatusWarningBorder1: "#fdcfb4",
  colorStatusWarningBorder2: "#bc4b09",
  colorStatusDangerBackground1: "#fdf3f4",
  colorStatusDangerBackground2: "#eeacb2",
  colorStatusDangerBackground3: "#c50f1f",
  colorStatusDangerForeground1: "#b10e1c",
  colorStatusDangerForeground2: "#6e0811",
  colorStatusDangerForeground3: "#c50f1f",
  colorStatusDangerForegroundInverted: "#dc626d",
  colorStatusDangerBorderActive: "#c50f1f",
  colorStatusDangerBorder1: "#eeacb2",
  colorStatusDangerBorder2: "#c50f1f",
  shadow2: "0 0 2px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.14)",
  shadow4:
    "0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)",
  shadow8:
    "0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)",
  shadow16:
    "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)",
  shadow28: "0 0 8px rgba(0,0,0,0.12), 0 14px 28px rgba(0,0,0,0.14)",
  shadow64:
    "0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)",
  shadow2Brand: "0 0 2px rgba(0,0,0,0.30), 0 1px 2px rgba(0,0,0,0.25)",
  shadow4Brand: "0 0 2px rgba(0,0,0,0.30), 0 2px 4px rgba(0,0,0,0.25)",
  shadow8Brand: "0 0 2px rgba(0,0,0,0.30), 0 4px 8px rgba(0,0,0,0.25)",
  shadow16Brand: "0 0 2px rgba(0,0,0,0.30), 0 8px 16px rgba(0,0,0,0.25)",
  shadow28Brand: "0 0 8px rgba(0,0,0,0.30), 0 14px 28px rgba(0,0,0,0.25)",
  shadow64Brand: "0 0 8px rgba(0,0,0,0.30), 0 32px 64px rgba(0,0,0,0.25)",
};
